import { render, staticRenderFns } from "./timeSetting.vue?vue&type=template&id=1c4e918c&scoped=true"
import script from "./timeSetting.vue?vue&type=script&lang=js"
export * from "./timeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e918c",
  null
  
)

export default component.exports